import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import EditCourseRow from "./EditCoursesRow";

const headers = [
  { name: "charter", display: "Charter", sortable: true },
  { name: "learningcenter", display: "Learning Center", sortable: true },
  { name: "courseassignments", display: "Course Offerings", sortable: false },
  { name: "editcourse", display: "Edit", sortable: false },
];

const TableHeaderItem = ({
  name,
  display,
  style,
  onClick,
  sortOptions,
  sortable,
}) => {
  return (
    <th style={{ ...style }} onClick={() => sortable && onClick(name)}>
      <div className="wrap">
        <span>{display}</span>
        {sortable && (
          <div className="filter">
            <FaIcons.FaSortUp
              style={{ color: sortOptions[name].asc ? "#343434" : "white" }}
            />
            <FaIcons.FaSortDown
              style={{ color: sortOptions[name].desc ? "#343434" : "white" }}
            />
          </div>
        )}
      </div>
    </th>
  );
};

const EditCourseTable = ({ items, courseid, permalink }) => {
  const [sortOptions, setSortOptions] = useState(
    headers.reduce((acc, header) => {
      acc[header.name] = { asc: false, desc: false };
      return acc;
    }, {})
  );

  const [sortedItems, setSortedItems] = useState(items);

  useEffect(() => {
    setSortedItems(items);
  }, [items]);

  const handleHeaderClick = (payload) => {
    if (!headers.find((header) => header.name === payload).sortable) {
      return;
    }
    let asc = sortOptions[payload].asc === false;
    let normal = sortOptions[payload].desc === true;

    const sortedItems = [...items].sort((a, b) => {
      if (normal) {
        return a[payload] < b[payload] ? 1 : -1;
      } else if (asc) {
        return a[payload] > b[payload] ? 1 : -1;
      } else {
        return a[payload] < b[payload] ? -1 : 1;
      }
    });

    setSortOptions((prevState) => ({
      ...headers.reduce((acc, header) => {
        acc[header.name] = { asc: false, desc: false };
        return acc;
      }, {}),
      [payload]: normal
        ? { asc: false, desc: false }
        : asc
        ? { asc: true, desc: false }
        : { asc: false, desc: true },
    }));

    setSortedItems(sortedItems);
  };

  return (
    <div className="interest-form-table">
      <table id="interest-table">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <TableHeaderItem
                key={index}
                name={header.name}
                display={header.display}
                style={header.style}
                onClick={handleHeaderClick}
                sortOptions={sortOptions}
                sortable={header.sortable}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(sortedItems) && sortedItems.length > 0 ? (
            sortedItems.map((item, index) => (
              <EditCourseRow
                key={index}
                info={item}
                courseid={courseid}
                permalink={permalink}
              />
            ))
          ) : (
            <tr>
              <td colSpan={headers.length}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EditCourseTable;
